<template>
    <v-row no-gutters class="pt-2">
        <v-col>
            <v-card>
                <v-skeleton-loader
                        type="table"
                        :boilerplate="!dataLoading"
                        v-if="showSkeleton"
                        max-height="350"
                ></v-skeleton-loader>
                <v-data-table
                        v-else
                        :dense="false"
                        hide-default-header
                        hide-default-footer
                        :headers="headers"
                        :items="clientTableData"
                        item-key="name"
                        @click:row="handleRowClick"
                        :options.sync="options"
                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.name" class="custom-row" @click="handleRowClick(item)">
                            <td
                                    v-for="h in headers"
                                    :key="h.value"
                                    class="custom-cell"
                                    :style="getCellStyle(h, item)"
                            >
                                {{
                                    h.value === "client_name" || h.value === "client_code"
                                            ? item[h.value]
                                            : h.value === "rules_percent"
                                                    ? Math.round(item[h.value]) + '%'
                                                    : Math.round(item[h.value])
                                }}
                            </td>
                        </tr>
                        </tbody>
                    </template>

                    <template v-slot:header="{ props }">
                        <thead>
                        <tr class="custom-row">
                            <th
                                    v-for="h in props.headers"
                                    :key="h.value"
                                    class="custom-cell header-text"
                                    :style="{ width: h.value === 'client_name' ? '15%' : '5%' }"
                            >
                                {{ t(h.text) }}
                            </th>
                        </tr>
                        </thead>
                    </template>

                    <template v-slot:footer="{ props }">
                        <v-row class="pr-8 py-3" align="center" justify="end" style="">
                            <span class="pagination-text mr-2" style="white-space: nowrap">
                                {{ t("Rows per page") }}:
                            </span>

                            <div class="dropdown-div">
                                <dropdown
                                        type="single"
                                        position="top"
                                        :items="rowsPerPageOptions"
                                        :show-search="false"
                                        :value="options.itemsPerPage"
                                        :field-height="36"
                                        @select="updateRowsPerPage"
                                />
                            </div>

                            <span class="mx-6 custom-pagination-location pagination-text">
                                {{ props.pagination.pageStart + 1 }}–{{ props.pagination.pageStop }} of
                                {{ props.pagination.itemsLength }}
                            </span>

                            <v-btn
                                    icon
                                    class="pagination-btn"
                                    @click="options.page--"
                                    :disabled="options.page <= 1"
                                    style="margin-right: 12px"
                                    :ripple="false"
                            >
                                <i class="fal fa-chevron-left"></i>
                            </v-btn>
                            <v-btn
                                    icon
                                    class="pagination-btn"
                                    @click="options.page++"
                                    :disabled="options.page >= props.pagination.pageCount"
                                    :ripple="false"
                            >
                                <i class="fal fa-chevron-right"></i>
                            </v-btn>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Dropdown from "@/components/dropdown/dropdown.vue";

export default {
    name: "analysis-table-row",
    components: { Dropdown },
    data() {
        return {
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            rowsPerPageOptions: [
                { text: "5", value: 5 },
                { text: "10", value: 10 },
                { text: "15", value: 15 },
            ],
        };
    },
    mounted() {
    },
    methods: {
        ...mapMutations("AnalysisStore", ["updateFilters"]),
        handleRowClick(row) {
            const newShop = row.client_name;
            const newClient = row.client;
            const newChain = row.chain_name;

            if (newClient && !this.filters.clients.includes(newClient)) {
                this.filters.clients = [...this.filters.clients, newClient];
            }
            if (newChain && !this.filters.chains.includes(newChain)) {
                this.filters.chains = [...this.filters.chains, newChain];
            }
            if (newShop && !this.filters.shops.includes(newShop)) {
                this.filters.shops = [...this.filters.shops, newShop];
            }

            this.updateFilters({ value: this.filters.shops, filter: "shops" });
            this.updateFilters({ value: this.filters.clients, filter: "clients" });
            this.updateFilters({ value: this.filters.chains, filter: "chains" });

            this.options.page = 1;
        },
        updateRowsPerPage(selectedValue) {
            this.options.itemsPerPage = selectedValue;
        },
        getCellStyle(h, item) {
            const boldKeys = ["client_name", "turnover_cy1cy2_diff"];
            let fontWeight = boldKeys.includes(h.value) ? "bold" : "normal";

            let color = "rgba(100, 100, 100, 1)";
            if (h.value === "client_name") {
                color = "black";
            } else if (h.value === "turnover_cy1cy2_diff") {
                const val = item[h.value];
                color = val > 0 ? "green" : val < 0 ? "red" : "inherit";
            }

            return { fontWeight, color };
        },
    },
    computed: {
        ...mapState("AnalysisStore", ["headers", "dataLoading", "showSkeleton", "filters", "clientTableData"]),
    },
};
</script>
<style scoped>
.custom-row {
    min-height: 40px;
    height: 40px;
}

.custom-cell {
    padding: 9px 20px;
    vertical-align: middle;
    font-size: 13px !important;
}

.header-text {
    color: rgba(141, 153, 146, 1) !important;
}

.cell-text {
    color: rgba(100, 100, 100, 1) !important;
}

.pagination-btn-wrapper {
    display: flex;
    gap: 12px;
}

.pagination-btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    gap: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn i {
    font-size: 20px;
}

.pagination-text {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    vertical-align: middle;
    color: rgba(141, 153, 146, 1);
}

.dropdown-div {
    width: 80px;
    height: 100%;
    display: flex;
    align-items: center;
}
</style>
